

















import {Vue, Prop, Component} from 'vue-property-decorator'
import {getPersianDate} from "@/util/utils";
import { DateBaseOnCurrentTimeConverter } from '@/util/dateConverter';
import * as enterpriseFormService from '@/store/Services/enterpriseFormService';
import store from '@/store';
import {ReceivedMessageFromFaxServiceDto} from '@/store/models/LetterOwner/RecievedMessageFromFaxServiceDto';

@Component
export default class Singlefax extends Vue{
    @Prop() faxData?: ReceivedMessageFromFaxServiceDto
    @Prop() serverTime?: string;
    get  sendTime(){
        if(this.faxData === undefined) return '';
        if(!this.serverTime) return '';
        const dateConverter = new  DateBaseOnCurrentTimeConverter();
        return   dateConverter.getDateString(new Date(this.faxData.time.substring(0,this.faxData.time.length -1)),this.serverTime)
    }

    select(){
        this.$emit("fax-selected",this.faxData);
    }
    
}



